import React, { useState } from 'react';
import ReactPlayer from 'react-player'; // For embedding YouTube video

const VideoLecture = () => {
  // Sample data for video lectures (can be replaced with dynamic data)
  const [lectures] = useState([
    {
      id: 1,
      title: 'Introduction to Computer Science',
      description: 'This is a basic introduction to computer science concepts.',
      youtubeLink: 'https://www.youtube.com/watch?v=_K7lj93Lof0&t=13s',
    },
    {
      id: 2,
      title: 'Advanced Programming Concepts',
      description: 'Learn advanced programming techniques and concepts.',
      youtubeLink: 'https://www.youtube.com/watch?v=_K7lj93Lof0&t=13s',
    },
    {
      id: 3,
      title: 'Data Structures and Algorithms',
      description: 'A comprehensive guide to understanding data structures and algorithms.',
      youtubeLink: 'https://www.youtube.com/watch?v=_K7lj93Lof0&t=13s',
    },
  ]);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-12">
      <div className="max-w-6xl w-full  rounded-lg border-4 border-teal-500 p-4">
        <h2 className="text-3xl font-bold text-white bg-teal-500 text-center mb-8 p-2 rounded-sm">
          Video Lectures for Students
        </h2>

        {/* Displaying the Video Lectures */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {lectures.map((lecture) => (
            <div
              key={lecture.id}
              className="bg-white rounded-lg shadow-lg p-4 transition-transform transform hover:scale-105"
            >
              <ReactPlayer
                url={lecture.youtubeLink}
                width="100%"
                height="250px"
                className="rounded-lg mb-4"
                playing={false}
              />

              <h3 className="text-xl font-semibold text-gray-800 mb-2">{lecture.title}</h3>
              <p className="text-gray-600 mb-4">{lecture.description}</p>
              <a
                href={lecture.youtubeLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-teal-500 hover:underline"
              >
                Watch on YouTube
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideoLecture;
